import React, {Fragment} from "react";
import config, { getApiUrl } from "./config";
import authService from "./AuthService";
import {Params} from "react-router-dom";
import {withRouter} from "./Utils";
import {JSONTree} from 'react-json-tree';
import toast from "react-hot-toast";

type ConfigurationParameter = {
    friendlyName: string
    key: string
    type: string
    constraint: string
    regex: string
    defaultValue: string
    description: string
}

type ApplicationComponentDetails = {
    friendlyName: string
    imageReference: string
    version: string
    architectures: Array<string>
    description: string
    changeLog: string
    configurationParameters: Array<ConfigurationParameter>
}

type ApplicationComponentProperties = {
    params?: Readonly<Params>
}

type ApplicationComponentState = {
    imageReference: string
    version: string
    details?: ApplicationComponentDetails
}

class ApplicationComponent extends React.Component<ApplicationComponentProperties, ApplicationComponentState> {
    constructor(props: ApplicationComponentProperties) {
        super(props);
        this.state = {
            imageReference: props.params!["imageReference"] || "",
            version: props.params!["version"] || ""
        }
    }

    componentDidMount() {
        this.fetchApplicationComponent()
    }

    private fetchApplicationComponent() {
        fetch(getApiUrl() + "/v1/component/application/reference/" + this.state.imageReference + "/version/" + this.state.version, {
            method: "GET",
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(async response => {
                if (response.ok) {
                    return await response.json() as Promise<ApplicationComponentDetails>
                } else if (response.status === 404) {
                    const body = await response.json()
                    toast.error("Error 404: " + body.message)
                }
            })
            .then((response) => {
                this.setState({
                    details: response
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }

    render() {
        return (
            <div className="Endpoint">
                <h2>{this.state.details?.friendlyName || ""}</h2>
                {this.renderDetails()}
            </div>
        );
    }

    renderDetails() {
        if (this.state.details !== undefined) {
            return (
                <JSONTree data={this.state.details} theme={{
                    extend: 'solarized',
                    base00: '#333',
                    base03: '#666',
                    base0D: '#8bb63a',
                    base0B: '#fff'
                }} shouldExpandNodeInitially={() => true} hideRoot={true}/>
            );
        } else {
            return <div>Loading...</div>;
        }
    }

}

const HOCApplianceComponent = withRouter(ApplicationComponent);
export default HOCApplianceComponent;
